import { createContext, useContext, useState, ReactNode } from "react";

export interface CartItem {
  id: string;
  name: string;
  tagline: string;
  price: number;
  unit: string;
  hours?: number;
  type?: 'plan' | 'tutor_session';
  teacherId?: string;
  subject?: string;
}

export interface CartContextType {
  items: CartItem[];
  drawerOpen: boolean;
  addItem: (item: CartItem) => void;
  removeItem: (id: string) => void;
  clearCart: () => void;
  openDrawer: () => void;
  closeDrawer: () => void;
}

const CartContext = createContext<CartContextType>({
  items: [], drawerOpen: false,
  addItem: () => {}, removeItem: () => {}, clearCart: () => {}, openDrawer: () => {}, closeDrawer: () => {},
});

export function CartProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<CartItem[]>([]);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const addItem = (newItem: CartItem) => { 
    setItems(prev => [...prev, newItem]); 
    setDrawerOpen(true); 
  };
  
  const removeItem = (id: string) => {
    setItems(prev => prev.filter(i => i.id !== id));
  };

  const clearCart = () => { setItems([]); };
  const openDrawer = () => setDrawerOpen(true);
  const closeDrawer = () => setDrawerOpen(false);

  return (
    <CartContext.Provider value={{ items, drawerOpen, addItem, removeItem, clearCart, openDrawer, closeDrawer }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
